export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_MESSAGE = 'SET_MESSAGE'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const CANCEL_NEWMESSAGE = 'CANCEL_NEWMESSAGE'
export const SET_MESSAGEACTIVATION = 'SET_MESSAGEACTIVATION'



// WEBPACK FOOTER //
// ./src/store/modules/message/types.js